import {
  CloseCircleOutlined,
  DeleteOutlined,
  DownloadOutlined,
  DownOutlined,
  EditOutlined,
  EyeOutlined,
  FilterOutlined,
  SettingOutlined,
  UserAddOutlined,
  UserOutlined
} from '@ant-design/icons';
import { AllCommunityModule, ColDef, ModuleRegistry } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { ConfigProvider, Input, Pagination } from 'antd';
import { PaginationProps } from 'antd/es/pagination/Pagination';
import viVN from 'antd/locale/vi_VN';
import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import * as customerApi from '../../api/customer/customerApi';
import { exportListCustomerExcel, getListCustomer_V2, getListFieldsByCustomer, ICustomer, IItemLast, ListField } from '../../api/Customer_V2/customerApi_V2';
import { getListOperatorFieldGroup, IOperatorFieldGroup, IOperatorFieldGroupV2, IVConditionFilterV2 } from '../../api/groupCustomerV2/groupCustomerV2Api';
import * as selectOptionsApi from '../../api/selectOptions/selectOptionsApi';
import { filterInfoOperatoToConditions } from '../../apiSync/customerGroup/customerGroupApi';
import BreadcrumbBlock from '../../components/BreadcrumbBlock/BreadcrumbBlock';
import ModalDeleteManager from '../../components/ModalDeleteManager';
import { NodataTable } from '../../components/NoDataTable';
import useDebounce from '../../hook/useDebounce';
import useLoading from '../../hook/useLoading';
import useThrottle from '../../hook/useThrottle';
import useToast from '../../hook/useToast';
import Layout from '../../Layout';
import { FIELDTYPE, NO_VIEW } from '../../services/data';
import { selectorInfoUser } from '../../store/slices/infoUserSlice';
import { checkDisabledPermission, CustomLoadingOverlayTable, dataPagination, formatPrice, generateColumnsFromCodesAgGridReact, getLastIdList, getLastItemList, getTitleSelectOption_V2, getUserPermissions } from '../../until';
import { initInfoOperator } from '../Customers/CustomerGroup/Component/Modal/ModalAddAndEditCondition';
import { ColumnKey } from '../Customers/Tabs/CarListCardClone';
import CustomerFeilds from './Drawer/CustomerFeilds';
import ModalCondition from './Modal/ModalCondition';
import './styles.scss';
import { selectorPermission } from '../../store/slices/permissionSlice';
import { formatNumber } from '../../services/mixin';
import { selectorCategoryCarIds } from '../../store/slices/categoryCarSlice';
import LoadingGlobal from '../../components/LoadingGLobal';
import { selectLoading } from '../../store/slices/loadingSlice';

ModuleRegistry.registerModules([AllCommunityModule])

export enum TYPECONDITION {
  GROUP = 0,
  CUSTOMER = 1,
}

// new filter

export interface IDataConditionDefaulFilterList {
  search?: string;
  isCustomer?: TYPECONDITION.GROUP | TYPECONDITION.CUSTOMER
}

export const dataConditionDefaulFilterList: IDataConditionDefaulFilterList = {
  search: undefined,
  isCustomer: undefined,
};
// end


export interface IDataDefaulFilterList {
  search: string;
  filterCustomerId: number | undefined;
  businessCheck: number[];
  gender: number[];
  listWard: number[];
  listArea: string[];
  listCategoryCar: number[];
  listSourceCustomer: number[];
  listUnit: number[];
  listCode: string[];
  listPhone: string[];
  listType: number[];
  dateStart: string;
  dateEnd: string;
  title: string; // Thêm trường titleFilter
  id: number | undefined;
  idDetailFilter: number | undefined
  listProvince: number[]
  listRank: number[]
}

// bộ lọc lớn
const dataDefaulFilter = {

  title: '' as string,
  id: undefined,
} as IDataDefaulFilterList

// filter cho bảng
export const dataDefaulFilterList = {
  ...dataDefaulFilter,
  age: [] as number[],
  price: [] as number[],
  search: "" as string, // Thêm trường search
  filterCustomerId: undefined as undefined | number, // Thêm trường filterCustomerId
  // listProvince: [] as number[],
  listDistrict: [] as number[],
  listWard: [] as number[],
  businessCheck: [] as number[],
  listCode: [] as string[],
  listPhone: [] as string[],
  listType: [] as number[],
  listRank: [] as number[],
  dateStart: "" as string,
  dateEnd: "" as string,
};

interface DataType {
  key: React.Key;
  stt: number;
  name: string;
  CCCD?: string;
  phone: string;
  birthday: string | undefined;
  gender: number;
  statusMarital: number;
  address?: string;
  email: string;
  province?: string;
  taxCode?: string;
  rankTitle?: string;
  profession?: string
  code?: string
  unit?: string
  permissionMenu?: customerApi.IPermissionMenu
}

export type FlattenedField = {
  id: number;
  fieldCode: string;
  fieldLabel: string;
  inputType: string;
  parentId: number;
  additionalData?: {
    colors: {
      bg: string
      text: string
      border: string
    }
  }
};


type GroupOption = {
  key: string;
  isGroup: true;
  title: string;

  fieldCode?: string;
};

type FieldOption = {
  key: string;
  value: number;
  label: string;
  parentKey: string;
  isGroup: false;
  fieldCode?: string;
};

export type OptionData = GroupOption | FieldOption;

const isFieldOption = (
  item: OptionData
): item is FieldOption => {
  return !item.isGroup;
};

export const buildOptions = (data: IOperatorFieldGroupV2[]): OptionData[] => {
  return data
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .flatMap((group) => [
      {
        key: `group-${group.id}`,
        isGroup: true as const,
        title: group.title,
      },
      ...group.children.map((item) => ({
        key: `${item.id}-${item.fieldCode}-group-${group.id}`,
        value: item.id,
        label: item.fieldLabel,
        isGroup: false as const,
        parentKey: `group-${group.id}`,
        id: item.id,
        fieldCode: item.fieldCode,
        fieldLabel: item.fieldLabel,
        inputType: item.inputType,
        type: item.type
      })),
    ]);
};


const requiredFieldCodes: string[] = [];
const CustomerList_V2: React.FC = () => {
  const location = useLocation();
  const pushToast = useToast();
  const navigator = useNavigate()
  const pushLoading = useLoading()

  const permissionSlice = useSelector(selectorPermission)
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)

  const { unitTemp } = useSelector(selectorInfoUser) // đợn vị dc chọn
  // const { add, download, delete: isdelete, share } = findChildIdByUrl(menuSlice, "/customer/list")

  const { add, edit, delete: isDelete, access, upload, download, share, } = getUserPermissions(permissionSlice, location.pathname)

  //#region: location restore

  const isFistRestore = useRef(false)
  const {
    firstPage,
    restorePagination, restoreDataFilterList
  } = location.state ?? {}
  //#endregion



  useEffect(() => {

    gListFieldsActive()

    const handleResize = () => {
      const baseFactor = (48 * 100) / 1440 / 100
      const factor = window.innerWidth > 1440 ? baseFactor * 0.9 : baseFactor
      const newHeight = Math.round(window.innerWidth * factor)
      setRowHeight(newHeight)
    }
    handleResize()

    window.addEventListener('resize', handleResize)

    return (() => {
      setPagination({ current: 1, pageSize: 30, total: 0 })
      setselectedIdCustomer(new Set())
      setItemLast(undefined)

      window.removeEventListener('resize', handleResize)
    })
  }, [])


  const [loadingTable, setLoadingTable] = useState(false)

  // lọc đk
  const [dataConditionFilter, setDataConditionFilter] = useState<IDataConditionDefaulFilterList>(dataConditionDefaulFilterList)

  const [isModalCondition, setModalCondition] = useState<boolean>(false)

  const [infoOperator, setInfoOperator] = useState<IVConditionFilterV2>(initInfoOperator)
  const [sLOperatorFieldGroup, setSLOperatorFieldGroup] = useState<IOperatorFieldGroupV2[]>([])
  const [sLListFilter, setSLListFilter] = useState<selectOptionsApi.ISelectOption[]>([])

  const [searchListFilter, setSearchListFilter] = useState<string>('')

  // HANDLE MODAL
  //Bộ lọc
  const [isModalFilterList, setIsModalFilterList] = useState(false);
  const [isSettingShow, setSettingShow] = useState(false)

  const [openDeleteListCustomer, setOpenDeleteListCustomer] = useState(false)

  const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0 });

  const [selectedIdCustomer, setselectedIdCustomer] = useState<Set<number>>(new Set());
  const [idCustomer, setIdCustomer] = useState<number | number[]>();
  const [itemLast, setItemLast] = useState<IItemLast>();


  //lọc ds bộ lọc
  const [dataFilterList, setDataFilterList] = useState<IDataDefaulFilterList>(dataDefaulFilterList)

  // Logic table mới
  const [rowHeight, setRowHeight] = useState(40)
  const [ColumnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([])
  const [dataFilterActive, setDataFilterActive] = useState<FlattenedField[]>([])
  const [dataFilterNoActive, setDataFilterNoActive] = useState<ListField[]>([])

  const [customerList, setcustomerList] = useState<ICustomer[]>([])

  //Kh có dk--------------------
  // const [infoCondFilterSync, setInfoCondFilterSync] =
  //   useState<{ matched: number[], unMatched: number[] }>({
  //     matched:
  //       [24, 17, 8, 10, 46, 43, 28, 27, 48, 32, 4, 19, 54, 26],
  //     unMatched: [
  //       1304, 1686, 2030, 1684, 2036, 3411, 2033, 1697, 1696, 5491, 1694, 9, 857, 1701, 862,
  //       1691, 2035, 2037, 35, 55, 2032, 16, 1690, 1693, 3, 58, 1699, 3313, 1303, 1703, 49, 1,
  //       2041, 6, 1687, 1707, 2031, 1695, 1692, 2034, 40, 33, 12, 1688, 18, 21, 51, 15, 29,
  //       856, 860, 2027, 1689, 1698, 864, 1709, 22, 859, 5, 861, 57, 3314, 2042, 39, 44,
  //       53, 2040, 2044, 2039, 863, 1708, 1705, 1704, 2029, 37, 1700, 31, 41, 2028, 855,
  //       962, 60, 50, 2043, 1685, 1706, 1702, 36, 2038, 7, 30, 858
  //     ]
  //   });


  //Kh có dk--------------------

  const actionColumn: ColDef = {
    headerName: 'Hành động',
    field: 'action',
    colId: 'action',
    width: 180,
    resizable: false,
    suppressMovable: true,
    lockPosition: 'left',
    headerComponentParams: {
      template: '<span class="w-full flex items-center justify-center">Hành động</span>'
    },
    cellRenderer: (params: any) => {
      const idCustomer = params.data.id
      const { view, edit, delete: isDelete } = params?.data?.permissionMenu
      // console.log(access, edit)
      return (
        <div className='d-flex gap-2 justify-center align-center  h-full px-1'>
          <EyeOutlined
            className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer ${!view && "disabled"}`}
            onClick={() => navigator(
              `/customer/list/edit`,
              {
                state: {
                  firstPage: "/customer/list",
                  id: idCustomer,
                  restorePagination: pagination,
                  restoreDataFilterList: dataFilterList
                }
              }
            )}
          />
          <EditOutlined
            className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer ${!edit && "disabled"}`}
            onClick={() => navigator(
              `/customer/list/edit`,
              {
                state: {
                  firstPage: "/customer/list",
                  id: idCustomer,
                  isEdit: true,
                  restorePagination: pagination,
                  restoreDataFilterList: dataFilterList
                }
              }
            )}
          />
          <DeleteOutlined
            className={`text-F5222D text-sm border-EAECF0 p-5-px bg-white rounded-2 cursor-pointer ${!isDelete && "disabled"}`}
            onClick={() => openModalDeleteListCustomer([Number(idCustomer)])}
          />
        </div>

      )
    },
  }

  const tableData: ICustomer[] = useMemo(() => {
    return customerList.map((item) => {
      const fieldValues = item.fields.reduce((acc: Record<string, any>, field) => {
        acc[field.fieldCode] = field.view ? field.value : NO_VIEW
        return acc
      }, {})

      Object.entries(requiredFieldCodes).forEach(([fieldCode, defaultValue]) => {
        if (!(fieldCode in fieldValues)) {
          fieldValues[fieldCode] = defaultValue
        }
      })
      return {
        ...item,
        key: item.id.toString(),
        ...fieldValues,
      }
    })
  }, [customerList])

  const memoizedColumnDefs = useMemo(() => {
    if (ColumnsMapShow.length)
      return generateColumnsFromCodesAgGridReact(
        ColumnsMapShow, dataFilterActive, dataFilterList,
        actionColumn,
        {
          setDataFilterList
        }
      );
  }, [ColumnsMapShow, dataFilterActive, dataFilterList, pagination]);

  // filter KH
  const gSLlistFilter = useDebounce(async () => {
    const {
      search, isCustomer = TYPECONDITION.CUSTOMER,
    } = dataConditionFilter
    const result = await selectOptionsApi.getSLlistFilter(search, isCustomer)
    if (result?.status) {
      setSLListFilter(result?.data)
    }
  }, 1000)

  const gInfoFilter = useDebounce(async (value: number) => {
    setModalCondition(true)
    setDataFilterList({ ...dataFilterList, idDetailFilter: value })
  }, 200)


  const gListOperatorFieldGroup = useDebounce(async () => {
    pushLoading(true)
    const result = await getListOperatorFieldGroup(searchListFilter
    )
    if (result?.status) {
      setSLOperatorFieldGroup(result.data)
    }
    pushLoading(false)
  }, 1000)

  // hàm xử lý select trường V2
  const options = useMemo(() => buildOptions(sLOperatorFieldGroup), [sLOperatorFieldGroup]);

  const selectableOptions = options.filter(
    (item) => !item.isGroup
  );
  // end


  const gListFieldsActive = async () => {
    pushLoading(true)
    const result = await getListFieldsByCustomer(FIELDTYPE.CUSTOMER, 1)
    if (result?.status) {
      const flattenedFields = result.data.flatMap(choice =>
        choice.fields.map(field => ({
          ...field,
          parentId: choice.id,
        }))
      );
      setDataFilterActive(flattenedFields)
      gListFieldsNotActive()
    }
    pushLoading(false)
  }

  const gListFieldsNotActive = async () => {
    const result = await getListFieldsByCustomer(FIELDTYPE.CUSTOMER, 0)
    if (result?.status) {
      setDataFilterNoActive(result.data)
    }
  }
  const gListCustomer = useDebounce(async (pageCurent: number = 1, pageSize: number = 20) => {
    setLoadingTable(true)
    const pageCurentTmp = isFistRestore.current ? restorePagination.current : pageCurent
    const pageSizeTmp = isFistRestore.current ? restorePagination.pageSize : pageSize

    const {
      filterCustomerId, gender, listArea, listWard,
      listCategoryCar, search, listSourceCustomer, listUnit, businessCheck,
      listCode, listPhone, listType, dateStart, dateEnd,
      listProvince,
      listRank
    } = dataFilterList

    const unitId = unitTemp ? unitTemp : undefined

    const conditions = filterInfoOperatoToConditions(infoOperator)
    const { lastId, updatedAt } = pageCurent === 1 ? { lastId: undefined, updatedAt: undefined } : itemLast ?? {}

    const result = await getListCustomer_V2(
      permittedCategoryCarIds,
      pageSizeTmp, pageCurentTmp, search, undefined,
      undefined, unitId, filterCustomerId,
      businessCheck, undefined, undefined, gender,
      undefined, listProvince, listWard,
      undefined, listRank, undefined, undefined,
      listCategoryCar, undefined, undefined, undefined,
      undefined, listUnit, undefined, undefined,
      undefined, undefined, undefined,
      undefined, listPhone, listType, listCode,
      undefined, undefined, dateStart, dateEnd,
      conditions, lastId, updatedAt
    )
    if (result?.status) {
      isFistRestore.current = false

      setcustomerList(result.data)
      setPagination({ current: pageCurentTmp, total: result.total, pageSize: pageSizeTmp })

      setItemLast(getLastItemList(result.data))
    } else {
      pushToast(result?.message, "warning")
    }
    setLoadingTable(false)
  }, 2000)

  //Bộ lọc ds khách hàng
  const onChangeFilterListName = (value: string) => {
    setDataFilterList({ ...dataFilterList, search: value })
  }

  const onChangeFilterListF = (value: number) => {
    setIsModalFilterList(false)
    setDataFilterList({ ...dataDefaulFilterList, filterCustomerId: value })
  }

  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    setPagination((prev) => ({ ...prev, current: pageNumber, pageSize }))
    gListCustomer(pageNumber, pageSize)
  }

  const { Search } = Input;

  // modal điều kiện
  const setActiveAddFilter = () => {
    setModalCondition(true)
  };

  const onSubmitFormModalSaveFilter = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      gSLlistFilter()
      setModalCondition(false)
      pushToast(message, "success")

    }
    else {
      pushToast(message, "warning")
    }
  }

  const handleClearFilter = () => {
    if (dataFilterList.filterCustomerId) {
      setDataFilterList({ ...dataFilterList, filterCustomerId: undefined })
      gListCustomer()
    }
    setIsModalFilterList(false)
  }

  // filter KH
  const onConfirmDeleteFilter = async (id: number) => {
    pushLoading(true)
    const result = await selectOptionsApi.deleteFilter(id)

    if (result?.status) {
      pushToast(result.message, "success")
      gSLlistFilter()
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }

  const openModalDeleteListCustomer = (id: number[]) => {
    setIdCustomer(id)
    setOpenDeleteListCustomer(true)
  }

  const closeModalDelete = () => {
    setIdCustomer(undefined)
    setOpenDeleteListCustomer(false)
  }


  const onConfirmDelete = async () => {
    const result = await customerApi.deleteCustomer(idCustomer)
    if (result?.status) {
      pushToast(result.message, "success")
      closeModalDelete()
      setselectedIdCustomer(new Set())
      gListCustomer(pagination.current, pagination.pageSize)
    } else {
      pushToast(result?.message, "warning")
    }
  }

  //XUAT EXEL TẤT CẢ DANH SÁCH -------
  const glistByExcel = useThrottle(async () => {
    pushLoading(true)

    const hasSelectedCustomer = selectedIdCustomer.size > 0;
    const selectedIdCustomerArr = hasSelectedCustomer ? [...selectedIdCustomer] : [];
    const dataFilterListTmp = hasSelectedCustomer ? {} as IDataDefaulFilterList : dataFilterList;
    const {
      filterCustomerId, gender, listArea, listWard,
      listCategoryCar, search, listSourceCustomer, listUnit, businessCheck,
      listCode, listPhone, listType, dateStart, dateEnd,
      listProvince, listRank
    } = dataFilterListTmp
    const conditions = hasSelectedCustomer ? [] : filterInfoOperatoToConditions(infoOperator);

    await exportListCustomerExcel(
      permittedCategoryCarIds,
      pagination.total, undefined, search, undefined,
      undefined, unitTemp, filterCustomerId,
      businessCheck, undefined, undefined, gender,
      undefined, listProvince, listWard,
      undefined, listRank, undefined, undefined,
      listCategoryCar, undefined, undefined, undefined,
      undefined, listUnit, undefined, undefined,
      undefined, undefined, undefined,
      undefined, listPhone, listType, listCode,
      undefined, undefined, dateStart, dateEnd,
      conditions, undefined, selectedIdCustomerArr
    )
    pushLoading(false)

  }, 1000)
  //XUAT EXEL TẤT CẢ DANH SÁCH END -----------

  const onSaveDataFields = (iSsuccess?: boolean, message?: string, dataFilterActive?: FlattenedField[], dataFilterNoActive?: ListField[]) => {
    if (iSsuccess) {
      setSettingShow(false)
      pushToast(message, "success")
      setDataFilterActive(dataFilterActive ?? [])
      setDataFilterNoActive(dataFilterNoActive ?? [])
      gListCustomer()

    } else {
      pushToast(message, "warning")
    }
  }

  const onCloseDataFields = () => {
    setSettingShow(false)
  }

  // Trong Ag-Grid, thêm onSelectionChanged
  const onSelectionChanged = (event: any) => {
    const selectedNodes = event.api.getSelectedNodes();
    const selectedIds = new Set<number>(
      selectedNodes.map((node: any) => Number(node.data.id))
    );
    setselectedIdCustomer(selectedIds);
  };


  useEffect(() => {
    gListOperatorFieldGroup()
  }, [searchListFilter])

  useEffect(() => {
    gSLlistFilter()
  }, [dataConditionFilter])

  // modal dk
  useEffect(() => {
    if (!sLOperatorFieldGroup.length && isModalCondition)
      gListOperatorFieldGroup()
  }, [isModalCondition])

  useEffect(() => {
    gListCustomer()
  }, [dataFilterList, infoOperator.conditions, unitTemp])

  useEffect(() => {
    const codes = dataFilterActive.map(f => f.fieldCode)
    setColumnsMapShow(codes)
  }, [dataFilterActive])

  //#region: location restore useEffect
  useEffect(() => {
    if (firstPage === "/customer/list/edit") {
      if (restoreDataFilterList) {
        setDataFilterList(restoreDataFilterList)
      }

      if (restorePagination) {
        isFistRestore.current = true
        gListCustomer(restorePagination.current, restorePagination.pageSize)
      }
    }
  }, [location.state])
  //#endregion

  return (
    <Fragment>
      <ModalCondition
        isOpen={isModalCondition}
        selectableOptions={selectableOptions}
        options={options}
        sLListFilter={sLListFilter}

        dataFilterList={dataFilterList}
        infoOperator={infoOperator}

        setIsModalFilterList={setIsModalFilterList}
        setDataFilterList={setDataFilterList}
        setInfoOperator={setInfoOperator}
        setSearchListFilter={setSearchListFilter}
        onSubmitFormModal={onSubmitFormModalSaveFilter}
        closeModal={setModalCondition}
      />

      <ModalDeleteManager
        isOpen={openDeleteListCustomer}
        title="Bạn có chắc chắn xóa khách hàng này"
        titleDelete="Xóa khách hàng"
        content="Khách hàng và dữ liệu liên quan sẽ bị xóa vĩnh viễn không thể khôi phục"
        closeModal={closeModalDelete}
        onConfirm={onConfirmDelete}
      />

      {
        isSettingShow ?
          <CustomerFeilds
            isSettingShow={isSettingShow}
            dataFilterActive={dataFilterActive}
            dataFilterNoActive={dataFilterNoActive}

            onSaveDataFields={onSaveDataFields}
            onClose={onCloseDataFields}
          /> :
          null
      }
      <Layout className='customer-list h-full'>
        <BreadcrumbBlock
          items={[
            { title: <Link to="/">THACO AUTO CRM</Link>, },
            { title: 'Khách hàng', },
            { title: 'Danh sách khách hàng', },
          ]}
          title={`Danh sách khách hàng (${formatPrice(pagination.total ?? 0)})`}
          className='gutter-block-end'
        />

        {/* Fillter block */}
        {
          selectedIdCustomer.size ? (
            //  Fillter block
            <div className={`filter-block filter-active-show active`}>
              <div className='total-chosse'>
                {`Đã chọn ${selectedIdCustomer.size} khách hàng`}
              </div>
              <div
                className={`btn-input ${checkDisabledPermission(download)}`}
                onClick={glistByExcel}
              >
                <div className="icon-svg">
                  <img src="/customer/down.svg" alt="" />
                </div>
                <div className="text">Xuất DS </div>
              </div>
              <div
                className="btn-input"
                onClick={() => openModalDeleteListCustomer(Array.from(selectedIdCustomer))}
              >
                <DeleteOutlined
                  className={`text-F5222D text-sm  ${!isDelete && "disabled"}`}

                />
                <div className="text">Xóa khách hàng</div>
              </div>
            </div>
          ) : (
            <div className={`filter-block active  filter-active-show`}>
              <div className='t-search-block-v1'>
                <Search
                  placeholder="Tìm kiếm thông tin khách hàng"
                  value={dataFilterList.search}
                  onChange={(e) => onChangeFilterListName(e.target.value)}
                />
              </div>

              <div className='filter-select'>
                <div
                  className='btn-select-show'
                >
                  <span
                    className="content-select"
                    onClick={() => setIsModalFilterList(true)} >
                    {
                      getTitleSelectOption_V2(
                        sLListFilter, Number(dataFilterList.filterCustomerId),
                        infoOperator.conditions[0].isAdd ? infoOperator.conditions.length : undefined, `Chọn bộ lọc`
                      )
                    }
                  </span>
                  <div
                    className={`icon-down ${isModalFilterList ? "active" : ""}`}
                    onClick={() => setIsModalFilterList(true)}
                  >
                    <DownOutlined />
                  </div>
                  <div
                    className={`icon-close ${isModalFilterList ? "active" : ""}`}
                    onClick={() => handleClearFilter()}
                  >
                    <CloseCircleOutlined />
                  </div>
                </div>
                <div className={`list-filter ${isModalFilterList ? "active" : ""}`}>
                  <Input
                    placeholder="Tìm kiếm bộ lọc"
                    value={dataConditionFilter.search}
                    onChange={e => setDataConditionFilter({ ...dataConditionFilter, search: e.target.value })}
                  />
                  <div className="list-item">
                    {
                      sLListFilter.map((item, i) => (
                        <div
                          key={i}
                          className={`item-select ${item.value === dataFilterList.filterCustomerId ? "bg-E6F7FF" : ""}`}

                        >
                          <div
                            className="icon-left w-full cursor-pointer"
                            onClick={() => onChangeFilterListF(item.value)}
                          >
                            <UserOutlined />
                            <div className="name-select">{item.label}</div>
                          </div>

                          <div
                            className="icon-left">
                            <EyeOutlined
                              onClick={() =>
                                gInfoFilter(item.value)
                              }
                            />
                          </div>
                          <div
                            className="icon-right">
                            <DeleteOutlined
                              onClick={() => onConfirmDeleteFilter(item.value)}
                            />
                          </div>
                        </div>
                      ))
                    }

                  </div>
                  <div
                    className="btn-filter"
                    onClick={setActiveAddFilter}
                  >
                    <div className="icon-btn-filter"><FilterOutlined /></div>
                    <div className="text-btn-filter">
                      Bộ lọc

                    </div>
                    <span className=' custom-page-css px-2 h-fit rounded-xl bg-white text-096DD9 text-sm'>{infoOperator.conditions[0].isAdd && infoOperator.conditions.length}</span>
                  </div>
                </div>
              </div>



              <div
                className={`btn-input  ${checkDisabledPermission(download)}`}
                onClick={glistByExcel}
              >
                <div className="icon-svg">
                  <DownloadOutlined />
                </div>
                <div className="text">Xuất DS</div>
              </div>

              <div
                className={`btn-input btn-primary  ${!add && "disabled"}`}
                onClick={() => navigator('/customer/list/add')}
              >
                <div className="icon-svg">
                  <UserAddOutlined />
                </div>
                <div className="text">Thêm khách hàng</div>
              </div>

              <div className="btn-input t-px-8" onClick={() => setSettingShow(true)}>
                <div className="icon-svg">
                  <SettingOutlined />
                </div>
              </div>
            </div>
          )
        }

        <div className={`order-history-card__body custom-page-css flex flex-1 flex-col justify-between`}>
          <div className="ag-theme-alpine custom-table-ag custom-css-table" style={{ width: '100%', height: 610 }}>
            <AgGridReact
              className="my-auto-height-grid"
              getRowStyle={(params: any) => ({
                backgroundColor: params?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
              })}
              rowData={tableData}
              columnDefs={memoizedColumnDefs}
              rowHeight={rowHeight}
              rowSelection={{ mode: 'multiRow' }}
              overlayNoRowsTemplate={NodataTable}
              loading={loadingTable}
              loadingOverlayComponent={CustomLoadingOverlayTable}
              // components={{
              //   loadingOverlay: LoadingGlobal,
              // }}
              // loadingCellRenderer={<LoadingGlobal/>}
              onSelectionChanged={onSelectionChanged}
              // Performance optimizations
              suppressColumnVirtualisation={true} // Giữ tất cả columns trong DOM
              suppressRowVirtualisation={false} // Giữ row virtualization
              enableCellTextSelection={true}
              ensureDomOrder={true}
              debounceVerticalScrollbar={true}
              suppressScrollOnNewData={true}
              suppressDragLeaveHidesColumns={true}

              // Thêm các props sau để cải thiện scroll
              rowBuffer={20}
              maxBlocksInCache={10}
              infiniteInitialRowCount={1000}
            />
          </div>

          <ConfigProvider locale={viVN}>
            <div className="pagination-block">
              <Pagination
                className='rs-pagination'
                showSizeChanger
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={pagination.total}
                pageSizeOptions={[10, 20, 50, 100]}
                itemRender={(page, type, originalElement) => {
                  // Chỉ custom khi là nút số trang
                  if (type === 'page') {
                    return <span>{formatNumber(page)}</span>;
                  }
                  // prev / next / jump-prev / jump-next giữ nguyên
                  return originalElement;
                }}
                showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
                onChange={onPaginationChange}
              />
            </div>
          </ConfigProvider>
        </div>
      </Layout>
    </Fragment>
  )
}

export default CustomerList_V2
